import React, { useState } from "react";
import { HistoryCard, OpenPositionsTable } from "./components";
import { FilterDropdown } from "@components/library/UI";

import btcIcon from "@assets/images/futures_pairs/btcusdt.svg";
import ethIcon from "@assets/images/futures_pairs/ethusdt.svg";
import bnbIcon from "@assets/images/futures_pairs/bnbusdt.svg";

import "./PositionsTab.sass";

// --- MOCK HISTORY DATA ---
const mockHistory = [
  {
    id: 1,
    icon: btcIcon,
    pair: "BTC/USDT",
    type: "Long",
    leverage: "3x",
    margin: "Cross",
    status: "Closed",
    entry: "89,869.5",
    pnl: "+$3,024.32",
    maxHeld: "1.0000 BTC",
    exit: "87,557.4",
    pnlPercent: "+43.32%",
    closedAmount: "1.0000 BTC",
    openedDate: "01/21/2026, 07:57:13",
    closedDate: "01/21/2026, 19:07:22",
  },
  {
    id: 2,
    icon: ethIcon,
    pair: "ETH/USDT",
    type: "Long",
    leverage: "10x",
    margin: "Isolated",
    status: "Closed",
    entry: "89,869.5",
    pnl: "+$3,024.32",
    maxHeld: "1.0000 BTC",
    exit: "87,557.4",
    pnlPercent: "+43.32%",
    closedAmount: "1.0000 BTC",
    openedDate: "01/21/2026, 07:57:13",
    closedDate: "01/21/2026, 19:07:22",
  },
  {
    id: 3,
    icon: bnbIcon,
    pair: "BNB/USDT",
    type: "Short",
    leverage: "5x",
    margin: "Cross",
    status: "Closed",
    entry: "89,869.5",
    pnl: "+$3,024.32",
    maxHeld: "1.0000 BTC",
    exit: "87,557.4",
    pnlPercent: "+43.32%",
    closedAmount: "1.0000 BTC",
    openedDate: "01/21/2026, 07:57:13",
    closedDate: "01/21/2026, 19:07:22",
  },
  {
    id: 4,
    icon: btcIcon,
    pair: "BTC/USDT",
    type: "Long",
    leverage: "3x",
    margin: "Cross",
    status: "Closed",
    entry: "89,869.5",
    pnl: "+$3,024.32",
    maxHeld: "1.0000 BTC",
    exit: "87,557.4",
    pnlPercent: "+43.32%",
    closedAmount: "1.0000 BTC",
    openedDate: "01/21/2026, 07:57:13",
    closedDate: "01/21/2026, 19:07:22",
  },
  {
    id: 5,
    icon: bnbIcon,
    pair: "BNB/USDT",
    type: "Short",
    leverage: "5x",
    margin: "Cross",
    status: "Closed",
    entry: "89,869.5",
    pnl: "+$3,024.32",
    maxHeld: "1.0000 BTC",
    exit: "87,557.4",
    pnlPercent: "+43.32%",
    closedAmount: "1.0000 BTC",
    openedDate: "01/21/2026, 07:57:13",
    closedDate: "01/21/2026, 19:07:22",
  },
];

export const PositionsTab = () => {
  const subTabs = ["Open Positions", "History"];
  const [activeSubTab, setActiveSubTab] = useState(subTabs[1]); // Set to History for testing

  // Dropdown States
  const [instrument, setInstrument] = useState("All Instruments");
  const [pair, setPair] = useState("All Pairs");
  const [closedFilter, setClosedFilter] = useState("Recently Closed");

  return (
    <div className="positions-tab">
      {/* 1. HEADER ROW (Pills + Conditional Dropdowns) */}
      <div className="positions-tab__header">
        <div className="positions-tab__pills">
          {subTabs.map((tab) => (
            <button
              key={tab}
              className={`positions-tab__pill ${
                activeSubTab === tab ? "positions-tab__pill--active" : ""
              }`}
              onClick={() => setActiveSubTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {activeSubTab === "History" && (
          <div className="positions-tab__dropdowns">
            {/* Dropdown 1: Instruments */}
            <FilterDropdown
              hasSearch={true}
              className="positions-tab__compact-dropdown"
              value={instrument}
              options={["All Instruments", "Crypto", "Fiat"]}
              onChange={setInstrument}
            />

            <FilterDropdown
              hasSearch={true}
              className="positions-tab__compact-dropdown"
              value={pair}
              options={[
                "All Pairs",
                "BTC-USDT-260227",
                "BTC-USDT-260327",
                "BTC-USDT-260626",
                "ETH/USDT",
              ]}
              onChange={setPair}
            />

            {/* Dropdown 3: Time Filter */}
            <FilterDropdown
              value={closedFilter}
              options={["Recently Closed", "Today", "This Week", "All Time"]}
              onChange={setClosedFilter}
            />
          </div>
        )}
      </div>

      {/* 2. CONTENT AREA */}
      <div className="positions-tab__content">
        {activeSubTab === "Open Positions" ? (
          <OpenPositionsTable />
        ) : (
          <div className="positions-tab__history-grid">
            {mockHistory.map((item) => (
              <HistoryCard key={item.id} data={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
